var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.5,
    height: 20,
    viewBox: "0 0 18 23",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0459 8.13232C11.0459 8.77037 10.7924 9.38229 10.3413 9.83345C9.8901 10.2846 9.27818 10.5381 8.64014 10.5381C8.00209 10.5381 7.39017 10.2846 6.93901 9.83345C6.48784 9.38229 6.23438 8.77037 6.23438 8.13232C6.23438 7.49428 6.48784 6.88236 6.93901 6.43119C7.39017 5.98003 8.00209 5.72656 8.64014 5.72656C9.27818 5.72656 9.8901 5.98003 10.3413 6.43119C10.7924 6.88236 11.0459 7.49428 11.0459 8.13232Z",
    stroke: "#3A4359",
    strokeWidth: 1.91
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6384 16.5137C15.9808 18.4267 16.6227 19.4458 16.2407 20.2667C16.2022 20.3488 16.1573 20.428 16.1059 20.5043C15.5526 21.3252 14.1236 21.3252 11.2655 21.3252H6.03639C3.17834 21.3252 1.75028 21.3252 1.19695 20.5043C1.14647 20.4284 1.10145 20.349 1.06223 20.2667C0.680197 19.4468 1.32205 18.4267 2.66447 16.5137",
    stroke: "#3A4359",
    strokeWidth: 1.91,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.85246 16.9525C9.52742 17.2881 9.0939 17.4755 8.64285 17.4755C8.19179 17.4755 7.75827 17.2881 7.43323 16.9525C4.46067 13.8623 0.47769 10.4106 2.41962 5.39893C3.47142 2.68863 5.99266 0.955078 8.64285 0.955078C11.293 0.955078 13.8152 2.68967 14.8661 5.39893C16.8061 10.4034 12.8327 13.8726 9.85246 16.9525Z",
    stroke: "#3A4359",
    strokeWidth: 1.91
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location-icon.c20c1be3405140d0ae6f3c35aed60ecd.svg";
export { ForwardRef as ReactComponent };